<script>
  import Email from '/srv/web/wyvr/html/releases/58819/gen/client/form/Email.svelte?1733898724738';
  import Dialog from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Dialog.svelte?1733898724738';
  import Spinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Spinner.svelte?1733898724738';
  import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724738';
  import ImageAttribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/ImageAttribute.svelte?1733898724738';
  import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898724738';
  import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724739';
  import Image from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/Image.svelte?1733898724739';
  import { notify } from '/srv/web/wyvr/html/releases/58819/gen/client/stock_notification/notify.js?1733898724739';

  export let product;
  export let open = false;

  $: sku = get_attribute_value(product, "sku");
  $: name = get_attribute_value(product, "name");
  $: image_src = get_attribute_value(product, "image");
  $: src = image_src ? get_image_path(image_src) : null;
  $: disabled = !sku || !email;

  let email = "";
  let state = "idle";

  async function action() {
    // @TODO validate email
    if (!sku || !email || email.indexOf("@") === -1) {
      messages.push(window.__("stock_notification.error"), "error");
      return;
    }
    state = "busy";

    const [error, id] = await notify(sku, email);
    if (error || !id) {
      messages.push(window.__("stock_notification.error"), "error");
    } else {
      messages.push(window.__("stock_notification.contains"), "success");
    }
    state = "idle";

    open = false;
  }
</script>

<Dialog
  id={"stock_notification"}
  bind:open
  title={window.__("stock_notification.name")}
>
  <div class="content">
    {#if state == "idle"}
      {#if name}
        <div>
          {#if product.image}
            <ImageAttribute {product} name="thumbnail" width={200} height={200} />
          {:else if product.thumbnail}
            <Image
                    src={get_attribute_value(product, 'thumbnail')}
                    width={200}
                    height={200}
                    alt={get_attribute_value(product, 'name')}
            />
          {/if}
          <b class="product-name">{@html name}</b>
        </div>
      {/if}
      <p>{window.__("stock_notification.description")}</p>
      <Email id={"stock_notification_email"} focus={open} bind:value={email}
        >{window.__("customer.email")}</Email
      >
      <div class="footer">
        <button
          class="btn login"
          type="submit"
          {disabled}
          on:click|preventDefault={action}
          >{window.__("stock_notification.action")}</button
        >
      </div>
    {:else}
      <Spinner />
    {/if}
  </div>
</Dialog>

<style>
  .product-name {
    color: var(--font-heading-color__base_light);
  }

  .footer {
    border-top: 1px solid var(--whitegray);
    padding: 15px 30px;
    margin-top: 1rem;
    align-items: center !important;
    justify-content: center !important;
    width: 100%;
  }
  .content :global(img) {
    border: none !important;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .content :global(.base){
    width: 100%;
  }
</style>